var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikelyApproveIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-6809 -2063 24.8 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.707;}.b{fill:#fff;}.b,.c{fill-rule:evenodd;}.c{fill:#ccc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-6809.1 -2062.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.1,12.3A12.4,12.4,0,1,1,12.5,24.8,12.42,12.42,0,0,1,.1,12.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M19.5,11.1H18.4v.6h.3a.882.882,0,0,1,.9.8.882.882,0,0,1-.9.8h-.9V14H18a.8.8,0,0,1,0,1.6h-.9v.6h.1a.806.806,0,1,1,0,1.6H12a9.43,9.43,0,0,1-2.7-.9,5.162,5.162,0,0,0-1.8-.6H4.7V10.1H7.4c1.2,0,1.8-.5,3.5-1.9a6.388,6.388,0,0,0,1.9-4.7c0-.3.4-.4.6-.4.3,0,1.1,0,1.1,1.7a11.943,11.943,0,0,1-1.1,4.3l-.2.5h6.2a.736.736,0,0,1,.8.8C20.4,10.7,20,11.1,19.5,11.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikelyApproveIcn);
export default __webpack_public_path__ + "static/media/likely_approve_icn.066ba358560151d37441533355cfbe6d.svg";
export { ForwardRef as ReactComponent };